export const NAV_COLORS = {
  taglineBlue: "#627DEB",
  nseText: "#0B0F14",
  liveGreen: "#00E676",
  inactiveNav: "#374151",
  activeGradientStart: "#3B82F6",
  activeGradientEnd: "#1D4ED8",
  divider: "#C3C3C3",
  iconBorder: "#C3C3C3",
  backButtonBg: "#F9FAFB",
  backButtonBorder: "#E5E7EB",
};

export const NAV_TRANSITION = "0.35s cubic-bezier(0.4, 0, 0.2, 1)";

export const ACTIVE_PILL_SX = {
  borderRadius: "40px",
  background: `linear-gradient(to right, ${NAV_COLORS.activeGradientStart}, ${NAV_COLORS.activeGradientEnd})`,
  border: "1px solid rgba(255, 255, 255, 0.3)",
  boxShadow: "0px 4px 12px -2px rgba(59, 130, 246, 0.2)",
};

export const HEADER_ICON_BUTTON_SX = {
  width: 40,
  height: 40,
  border: `1px solid ${NAV_COLORS.iconBorder}`,
  borderRadius: { xs: "999px", md: "12px" },
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow:
    "0px 2px 4px -2px rgba(0,0,0,0.1), 0px 4px 6px -1px rgba(0,0,0,0.1)",
  cursor: "pointer",
  position: "relative",
  overflow: "hidden",
  flexShrink: 0,
  bgcolor: "#fff",
  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    backdropFilter: "blur(16px)",
    borderRadius: "inherit",
    pointerEvents: "none",
  },
};

export const HEADER_HEIGHT = { xs: 70, md: 76, lg: 90 };

/** Approx StockTicker bar height (padding + line). Keep in sync with StockTicker styles. */
export const TICKER_HEIGHT = { xs: 28, md: 42 };

/** Total occupied height when header is fixed (includes notch / status bar). */
export const NATIVE_HEADER_OFFSET = {
  xs: `calc(${HEADER_HEIGHT.xs}px + env(safe-area-inset-top, 0px))`,
  md: `calc(${HEADER_HEIGHT.md}px + env(safe-area-inset-top, 0px))`,
  lg: `calc(${HEADER_HEIGHT.lg}px + env(safe-area-inset-top, 0px))`,
};

/** Native: fixed header + fixed ticker stacked under it. */
export const NATIVE_HEADER_WITH_TICKER_OFFSET = {
  xs: `calc(${HEADER_HEIGHT.xs}px + ${TICKER_HEIGHT.xs}px + env(safe-area-inset-top, 0px))`,
  md: `calc(${HEADER_HEIGHT.md}px + ${TICKER_HEIGHT.md}px + env(safe-area-inset-top, 0px))`,
  lg: `calc(${HEADER_HEIGHT.lg}px + ${TICKER_HEIGHT.md}px + env(safe-area-inset-top, 0px))`,
};

/** Mobile-web sticky ticker sits exactly under sticky navbar. */
export const STICKY_TICKER_SX = {
  position: { xs: "sticky", md: "relative" },
  top: { xs: HEADER_HEIGHT.xs, md: "auto" },
  zIndex: { xs: 1090, md: "auto" },
  bgcolor: "#fff",
  flexShrink: 0,
};

/** Native app: pin ticker flush under fixed header. */
export const NATIVE_STICKY_TICKER_SX = {
  position: "fixed",
  top: NATIVE_HEADER_OFFSET,
  left: 0,
  right: 0,
  zIndex: 1090,
  bgcolor: "#fff",
  flexShrink: 0,
};

export const HEADER_SX = {
  bgcolor: "#fff",
  px: { xs: 2.5, md: 4, lg: "60px" },
  height: HEADER_HEIGHT,
  minHeight: HEADER_HEIGHT,
  display: "flex",
  alignItems: "center",
  boxSizing: "border-box",
  flexShrink: 0,
  position: { xs: "sticky", md: "relative" },
  top: { xs: 0, md: "auto" },
  zIndex: { xs: 1100, md: "auto" },
  // Border lives on sticky ticker under the header on mobile
  borderBottom: {
    xs: "none",
    md: "none",
  },
  boxShadow: {
    xs: "none",
    md: "0px 4px 7px rgba(0, 0, 0, 0.15)",
  },
};

/** Android / iOS: pin header to the top of the viewport. */
export const NATIVE_HEADER_SX = {
  ...HEADER_SX,
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1100,
  pt: "env(safe-area-inset-top, 0px)",
  height: NATIVE_HEADER_OFFSET,
  minHeight: NATIVE_HEADER_OFFSET,
  borderBottom: "none",
  boxShadow: "none",
};

export const NAV_ITEM_GAP = { xs: 2, md: 4, lg: 6 };
